define("vod/main", ["jquery", "app", "lazyload","jquerycookie"], function ($, app , lazyload,jquerycookie) {
    app.render_page("vod");
});
require(['vod/main']);
